module.exports = __webpack_public_path__ + "img/2.1f86b4ab.jpg";